import { useNavigate } from 'react-router-dom';
import { formatTime } from '../helpers/formatTime'
import configData from '../config.json';


const SmallHighlightedVideo = ({ video, activeCategory, setActiveCategory, setActiveVideo, fromPage }) => {

  let navigate = useNavigate(); 
  const navigateTo = () =>{ 
    var path = '/video/' + (activeCategory.flatName).replace(/\s/g, '-') + '/' + video.id + '/' + (video.flatTitle).replace(/\s/g, '-');
    navigate(path);
  }

  const changeActiveVideo = () => {
 
    localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_VIDEO_URL, JSON.stringify(video.url));
    localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_VIDEO, JSON.stringify(video));
    localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_CATEGORY, JSON.stringify(activeCategory));

    setActiveVideo(video);
    setActiveCategory(activeCategory);
  };

  const scroll = () => {
    window.scrollTo({top: 0, left: 0});
  };

  return (
    <>
            <a className="d-side-video-thumbnail" style={{"cursor": "pointer"}} onClick={() => {changeActiveVideo();  navigateTo(); scroll();}}>
                <div className="d-video-cover-image">
                    <div className="d-play-icon">
                        <svg className="d-svg-icon"><use xlinkHref="#play" /></svg>
                    </div>
                    <img alt="" src={video.thumbnail}/>
                </div>
                <h3 className="d-ext-video-title d-ext-video-title-sm">
                    <span className="d-text">{video.title}</span> 
                    <label className="d-ext-video-duration">{formatTime(video.duration)}</label>
                </h3> 
            </a>
    </>
  );
};

export default SmallHighlightedVideo;